"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
var WithData = function WithData(mapDataToProps, Component) {
    return function (props) {
        var newProps = Object.assign({}, props, mapDataToProps(props.data));
        return /*#__PURE__*/ react_1.default.createElement(Component, newProps);
    };
};
exports.default = WithData;
